// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stone-rebrand-logo__svg[data-v-5afb1dfc] {\n  display: block;\n  height: 32px;\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
